import { render } from "./EmbedCodeWidget.vue?vue&type=template&id=89392f68"
import script from "./EmbedCodeWidget.vue?vue&type=script&setup=true&lang=js"
export * from "./EmbedCodeWidget.vue?vue&type=script&setup=true&lang=js"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__file',"src/components/Moleculas/EmbedCodeWidget.vue"]])
/* hot reload */
if (module.hot) {
  __exports__.__hmrId = "89392f68"
  const api = __VUE_HMR_RUNTIME__
  module.hot.accept()
  if (!api.createRecord('89392f68', __exports__)) {
    api.reload('89392f68', __exports__)
  }
  
  module.hot.accept("./EmbedCodeWidget.vue?vue&type=template&id=89392f68", () => {
    api.rerender('89392f68', render)
  })

}


export default __exports__